<template>
  <b-overlay :show="show" rounded class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">
      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <vuexy-logo />
        <h2 class="brand-text text-primary ml-1">
          Vuexy
        </h2> -->
        <b-img fluid :src="imgLogo" alt="Login V2" />
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col lg="8" class="d-none d-lg-flex align-items-center p-5">
        <div
          class="w-100 d-lg-flex align-items-center justify-content-center px-5"
        >
          <b-img fluid :src="imgUrl" alt="Login V2" />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col lg="4" class="d-flex align-items-center auth-bg px-2 p-lg-5">
        <b-col sm="8" md="6" lg="12" class="px-xl-2 mx-auto">
          <b-button
            :href="
              this.portlaUrl +
                'OAuthLogin?client_id=FE4FC3BC-287F-400D-2770-08D7C4BA67BA&client_secret=FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF&redirect_uri=' +
                this.ocpbComplaintUrl +
                'login'
            "
            variant="primary"
            block
          >
            login
          </b-button>
          <!-- <a
            href="https://portal.ocpb.go.th/OAuthLogin?client_id=FE4FC3BC-287F-400D-2770-08D7C4BA67BA&client_secret=FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF&redirect_uri=http://localhost:8080/authen"
            >login</a
          > -->

          <!-- <b-card-title class="mb-1 font-weight-bold" title-tag="h2">
            Welcome to Vuexy! 👋
          </b-card-title>
          <b-card-text class="mb-2">
            Please sign-in to your account and start the adventure
          </b-card-text>

          <b-alert variant="primary" show>
            <div class="alert-body font-small-2">
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Admin:</span> admin@demo.com |
                  admin</small
                >
              </p>
              <p>
                <small class="mr-50"
                  ><span class="font-weight-bold">Client:</span> client@demo.com
                  | client</small
                >
              </p>
            </div>
            <feather-icon
              v-b-tooltip.hover.left="'This is just for ACL demo purpose'"
              icon="HelpCircleIcon"
              size="18"
              class="position-absolute"
              style="top: 10; right: 10;"
            />
          </b-alert>

          form
          <validation-observer ref="loginForm" #default="{invalid}">
            <b-form class="auth-login-form mt-2" @submit.prevent="login">
              email
              <b-form-group label="Email" label-for="login-email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  vid="email"
                  rules="required|email"
                >
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    :state="errors.length > 0 ? false : null"
                    name="login-email"
                    placeholder="john@example.com"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              forgot password
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Password</label>
                  <b-link :to="{ name: 'auth-forgot-password' }">
                    <small>Forgot Password?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="Password"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              checkbox
              <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group>

              submit buttons
              <b-button
                type="submit"
                variant="primary"
                block
                :disabled="invalid"
              >
                Sign in
              </b-button>
            </b-form>
          </validation-observer>

          <b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link :to="{ name: 'auth-register' }">
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>

          divider
          <div class="divider my-2">
            <div class="divider-text">
              or
            </div>
          </div>

          social buttons
          <div class="auth-footer-btn d-flex justify-content-center">
            <b-button variant="facebook" href="javascript:void(0)">
              <feather-icon icon="FacebookIcon" />
            </b-button>
            <b-button variant="twitter" href="javascript:void(0)">
              <feather-icon icon="TwitterIcon" />
            </b-button>
            <b-button variant="google" href="javascript:void(0)">
              <feather-icon icon="MailIcon" />
            </b-button>
            <b-button variant="github" href="javascript:void(0)">
              <feather-icon icon="GithubIcon" />
            </b-button>
          </div> -->
        </b-col>
      </b-col>
    </b-row>
    <ModalMaintenance
      ref="ModalMaintenance"
      :maintenance="maintenance"
      :login:"true"
    ></ModalMaintenance>
  </b-overlay>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BOverlay,
} from "bootstrap-vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import useJwt from "@/auth/jwt/useJwt";
import { initialAbility } from "@/libs/acl/config";
import store from "@/store/index";
import * as oauthStore from "@/store/api/oauth/index.js";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";

import appsettings from "@/store/app-settings";
import { axiosPostOAuth } from "@/store/api/axiosUtils.js";

import * as apiEditDom from "@/store/api/editorDom/index.js";
import ModalMaintenance from "@/views/Complaint/components/ModalMaintenance.vue";

const urlAuthToken = appsettings.OAuthAPIUrl + "api/AuthToken";
const urlPersonalInfo = appsettings.OAuthAPIUrl + "api/AuthPersonalInfo";
const params = new URLSearchParams();
params.append("client_id", "FE4FC3BC-287F-400D-2770-08D7C4BA67BA");
params.append("client_secret", "FE4FC3BC-287F-4E2D-2770-08D7C4BA67FF");
params.append("grant_type", "authorization_code");

export default {
  beforeCreate: function() {
    let isLogin = false;
    let isLoginData = false;

    let getTokenKeyName = localStorage.getItem(
      useJwt.jwtConfig.storageTokenKeyName
    );
    let getRefreshTokenKeyName = localStorage.getItem(
      useJwt.jwtConfig.storageRefreshTokenKeyName
    );

    if (this.$route.query.code != null || this.$route.query.AuthenKey != null) {
      isLogin = true;
    }

    if (getTokenKeyName != null || getRefreshTokenKeyName != null) {
      isLoginData = true;
    }

    var _this = this;
    if (isLogin === false && isLoginData == true) {
      window.open(
        _this.$router.resolve({ name: "ComplaintMainSearch" }).href,
        "_self"
      );
    } else {
      localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
      localStorage.removeItem("userData");
      this.$ability.update(initialAbility);
    }
  },
  // beforeCreate: function() {
  //   localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName);
  //   localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName);
  //   localStorage.removeItem('userData');
  //   this.$ability.update(initialAbility);
  // },
  created: function() {
    //this.login()

    this.ocpbComplaintUrl = appsettings.ocpbComplaintUrl;
    this.portlaUrl = appsettings.OAuthLogin;

    let isPortal = false;
    let authKey = null;

    if (this.$route.query.code != null) {
      authKey = this.$route.query.code;
    } else if (this.$route.query.AuthenKey != null) {
      authKey = this.$route.query.AuthenKey;
      isPortal = true;
    }

    const _this = this;
    if (authKey != null) {
      const params = {
        token: authKey,
        isPortal: isPortal,
      };

      _this.show = true;

      oauthStore
        .postAuthToken(params)
        .then((response) => {
          if (response.data.success === true) {
            const responseData = response.data.data;
            let payload = response.data.data.payload;

            useJwt.setToken(responseData.access_token);
            useJwt.setRefreshToken(responseData.refresh_token);

            const fixAbility = [
              {
                action: "manage",
                subject: "all",
              },
            ];

            payload.ability = fixAbility;
            localStorage.setItem("userData", JSON.stringify(payload));

            _this.$ability.update(payload.ability);

            /// เพิ่มเงื่อนไขถ้าเป็นเจ้าหน้าที่ กทม จะ redirect ไปหน้าเรื่องร้องเรียน กทม
            /// console.log("payload.selectedRole", payload.selectUserRole);
            if (
              payload.selectUserRole &&
              payload.selectUserRole.value &&
              payload.selectUserRole.value.toLowerCase() ===
                appsettings.complaintRoleId.bangkok.toLowerCase()
            ) {
              //console.log("bangkok");
              window.open(
                _this.$router.resolve({ name: "BangkokOfficer" }).href,
                "_self"
              );
            } else {
              //console.log("other");
              // then we must redirect
              window.open(
                _this.$router.resolve({ name: "ComplaintMainSearch" }).href,
                "_self"
              );
            }

            _this.$bvToast.toast("เข้าสู่ระบบสำเร็จ", {
              title: `เข้าสู่ระบบสำเร็จ`,
              variant: "success",
              solid: false,
            });

            _this.show = false;
          } else {
            _this.$bvToast.toast("เกิดข้อผิดพลาด", {
              title: `เกิดข้อผิดพลาดในการเข้าสู่ระบบ`,
              variant: "danger",
              solid: false,
            });

            _this.show = false;
          }
        })
        .catch((err) => {
          console.log("err", err);
          _this.show = false;
        });
    }
  },
  //   // if (this.$route.query.code != null) {
  //   //   const headerToken = {
  //   //     headers: {
  //   //       Authorization: "Basic " + this.$route.query.code,
  //   //       "Content-Type": "application/x-www-form-urlencoded",
  //   //     },
  //   //   };
  //   //   axiosPostOAuth(urlAuthToken, params, headerToken)
  //   //     .then(function(response) {
  //   //       //console.log("urlAuthToken", response);
  //   //       const headerPersonalInfo = {
  //   //         headers: {
  //   //           Authorization: "Basic " + response.data.access_token,
  //   //           "Content-Type": "application/x-www-form-urlencoded",
  //   //         },
  //   //       };
  //   //       axiosPostOAuth(urlPersonalInfo, params, headerPersonalInfo)
  //   //         .then(function(response) {
  //   //           //console.log("urlPersonalInfo", response.data);
  //   //           useJwt.setToken(response.data.access_token);
  //   //           useJwt.setRefreshToken(response.data.refresh_token);

  //   //           const fixAbility = [
  //   //             {
  //   //               action: "manage",
  //   //               subject: "all",
  //   //             },
  //   //           ];

  //   //           response.data.payload.ability = fixAbility;
  //   //           localStorage.setItem(
  //   //             "userData",
  //   //             JSON.stringify(response.data.payload)
  //   //           );

  //   //           _this.$ability.update(response.data.payload.ability);

  //   //           // then we must redirect
  //   //           window.open(
  //   //             _this.$router.resolve({ name: "dashboard-ecommerce" }).href,
  //   //             "_self"
  //   //           );
  //   //         })
  //   //         .catch(function(error) {
  //   //           console.log(error);
  //   //         });
  //   //     })
  //   //     .catch(function(error) {
  //   //       console.log(error);
  //   //     });
  //   // }
  // },
  directives: {
    "b-tooltip": VBTooltip,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    BOverlay,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    ModalMaintenance,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: "",
      password: "admin",
      userEmail: "admin@demo.com",
      sideImg: require("@/assets/images/pages/landingpage.png"),
      logoImg: require("@/assets/images/pages/logoText.png"),

      // validation rules
      required,
      email,
      ocpbComplaintUrl: "",
      portalUrl: "",
      show: false,
      maintenance: "",
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    imgUrl() {
      // if (store.state.appConfig.layout.skin === "dark") {
      //   // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      //   this.sideImg = require("@/assets/images/pages/login-v2-dark.svg");
      //   return this.sideImg;
      // }
      return this.sideImg;
    },
    imgLogo() {
      return this.logoImg;
    },
  },
  mounted() {
    if (this.$route.query.code) {
      console.log("back");
    } else {
      this.onGetMaintenance();
    }
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          useJwt
            .login({
              email: this.userEmail,
              password: this.password,
            })
            .then((response) => {
              //console.log("response", response);
              const { userData } = response.data;
              useJwt.setToken(response.data.accessToken);
              useJwt.setRefreshToken(response.data.refreshToken);
              localStorage.setItem("userData", JSON.stringify(userData));
              this.$ability.update(userData.ability);

              // ? This is just for demo purpose as well.
              // ? Because we are showing eCommerce app's cart items count in navbar
              this.$store.commit(
                "app-ecommerce/UPDATE_CART_ITEMS_COUNT",
                userData.extras.eCommerceCartItemsCount
              );

              // ? This is just for demo purpose. Don't think CASL is role based in this case, we used role in if condition just for ease
              // this.$router.replace(getHomeRouteForLoggedInUser(userData.role))
              //   .then(() => {
              //     this.$toast({
              //       component: ToastificationContent,
              //       position: 'top-right',
              //       props: {
              //         title: `Welcome ${userData.fullName || userData.username}`,
              //         icon: 'CoffeeIcon',
              //         variant: 'success',
              //         text: `You have successfully logged in as ${userData.role}. Now you can start to explore!`,
              //       },
              //     })
              //   })
            })
            .catch((error) => {
              this.$refs.loginForm.setErrors(error.response.data.error);
            });
        }
      });
    },
    onGetMaintenance() {
      apiEditDom
        .getById("Maintenance")
        .then((response) => {
          // console.log("onGetMaintenance: response", response);
          if (response.data.data !== null && response.data.data !== undefined) {
            // console.log(
            //   "onGetMaintenance: response.data.data",
            //   response.data.data
            // );
            this.maintenance = response.data.data.domTh;
            this.$refs.ModalMaintenance.$refs["modal-maintenance"].show();
          }
        })
        .catch((error) => {
          console.log("error", error);
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>
